export default [
	{
		path: '/about/companies-introduce',
		name: 'companiesIntroduce',
		meta: {
			title: '企业介绍',
			title2: '企业介绍-华略未来科技',
		},
		component: () => import('views/about/companiesIntroduce/companiesIntroduce.vue'),
	},
	{
		path: '/about/social-responsibility',
		name: 'socialResponsibility',
		meta: {
			title: '社会责任',
			title2: '社会责任-华略未来科技',
		},
		component: () => import('views/about/socialResponsibility/socialResponsibility.vue'),
	},
	{
		path: '/about/contact',
		name: 'contact',
		meta: {
			title: '联系方式',
			title2: '联系方式-华略未来科技',
		},
		component: () => import('views/about/contact/contact.vue'),
	},
];

